import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../api/axiosInterceptor';
import SyncLoader from "../components/Loader";

const Logout = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false); 
  useEffect(() => {
    const logoutUser = async () => {
    setIsLoading(true);
      try {
        // Get tokens from localStorage
        const accessToken = localStorage.getItem('accessToken');
        const refreshToken = localStorage.getItem('refreshToken');

        if (accessToken && refreshToken) {
          // Make API call to log out the user
          await axiosInstance.post('/logout/', 
            { refresh: refreshToken }, // 👈 Pass refresh token in body
            {
              headers: {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
              },
            }
          );
        }

        // Clear session data
        localStorage.clear(); // Remove stored data like tokens and user details

        // Redirect to login page
        navigate('/');
      } catch (error) {
        console.error('Logout failed:', error);
        // Still redirect user even if logout API fails
        navigate('/');
      }
      finally {
        setIsLoading(false); // Stop the loader
      }
    };

    logoutUser();
  }, [navigate]);

  return (
    <>
    {isLoading && <SyncLoader message="Logging out" />}
    </>
  );
};

export default Logout;